export default "__VITE_ASSET__CF$9Y__Y__"